 <template>
  <a
    rel="noopener"
    target="_blank"
    class="help-center-external-link__component"
    :href="externalLink.url"
    :class="className"
    :data-directus-hide="externalLink.hide_lower_or_equal"
  >
    {{ externalLink.title }}
    <HelpCenterIcon
      v-if="externalLink.with_icon"
      name="externalLink"
      size-units="4"
    />
  </a>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterIcon from 'help-center/components/HelpCenterIcon'

const props = defineProps({
  externalLink: {
    type: Object,
    required: true
  }
})

const className = computed(() => {
  if (props.externalLink.with_highlight) {
    return 'help-center-external-link__component--highlight'
  } else {
    return 'help-center-external-link__component--accent'
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-external-link {
  &__component {
    &--accent {
      @include help-center-accent-link;
    }

    &--highlight {
      @include help-center-highlight-link;
    }

    @include help-center-font(14);
    @include help-center-hide-by-directus-attr;

    gap: 4px;
    display: flex;
    align-items: center;

    padding: 4px;
    text-align: right;
    font-weight: var(--help-center-bold);
    text-transform: uppercase;
  }
}
</style>
